export enum TiposNaturezaAjusteEnum {
    ACRESCIMO_VALOR = 1,
    ACRESCIMO_VALOR_PRAZO = 2,
    AJUSTE_PRAZO = 3,
    AJUSTE_SEM_ALTERACAO = 4,
    SUPRESSAO_VALOR_PRAZO = 5,
    SUPRESSAO_VALOR_PRORROGACAO_PRAZO = 6,
    SUPRESSAO_VALOR = 7,
    ALTERACAO_CONTRATADO = 8,
    ALTERACAO_CONTRATADO_ACRESCIMO_VALOR = 9,
    ALTERACAO_CONTRATADO_SUPRESSAO_VALOR = 10
  }